module.exports = __webpack_public_path__ + "static/img/ppsj.85020d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/ppsj.png
// module id = EcPi
// module chunks = 1